module.exports = __webpack_public_path__ + "static/media/20.f2376521.png";